export enum UserRoles {
  SALES_PERSON = "Sales Person",
  ACCOUNTS_PERSON = "Accounts Person",
}

export enum UserRoleActions {
  REVIEW = "Review",
  EDIT = "Edit",
  VIEW = "View",
  ALLOW = "On",
  DATA_INPUT = "Data Input",
  MANAGER_REVIEW = "Manager Review",
  ARCHIVED_VIEW = "Archived View",
  ARCHIVED_EDIT = "Archived Edit",
  INTERNAL_APPROVAL = "Internal Approval",
}
